"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.downloadFileSaga = downloadFileSaga;
exports.getDocumentSaga = getDocumentSaga;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url-search-params.js");
var _effects = require("redux-saga/effects");
var _paulCorePackage = require("paul-core-package");
var _api = require("../../utils/api");
function getDocumentSaga(_ref) {
  let {
    type,
    payload: {
      siteId
    }
  } = _ref;
  return function* () {
    try {
      const token = yield (0, _effects.select)(_paulCorePackage.selectors.getToken);
      const {
        api: apiURL
      } = yield (0, _effects.select)(_paulCorePackage.selectors.getUrls);
      const resp = yield (0, _effects.call)(_api.getAPIDocuments, {
        prefUrl: apiURL,
        token,
        siteId
      });
      const parseResp = yield (0, _effects.call)(() => resp.json());
      yield (0, _effects.put)((0, _paulCorePackage.requestSuccess)(type, {
        data: parseResp,
        requestData: {
          siteId
        }
      }));
    } catch (error) {
      /** add error handler */
      // eslint-disable-next-line no-console
      yield (0, _effects.call)(() => console.log('catch', error, type));
      yield (0, _effects.put)((0, _paulCorePackage.requestError)(type, {
        message: error.formError
      }));
    }
  }();
}
function downloadFileSaga(_ref2) {
  let {
    type,
    payload: {
      url,
      filename
    }
  } = _ref2;
  return function* () {
    try {
      const token = yield (0, _effects.select)(_paulCorePackage.selectors.getToken);
      const resp = yield (0, _effects.call)(_api.downloadFileAPI, {
        token,
        url
      });
      const respBlob = yield (0, _effects.call)(() => resp.blob());
      const href = yield (0, _effects.call)(() => window.URL.createObjectURL(new Blob([respBlob])));
      const link = yield (0, _effects.call)(() => document.createElement('a'));
      link.href = yield (0, _effects.call)(() => href);
      link.download = yield (0, _effects.call)(() => filename);
      yield (0, _effects.call)(() => document.body.appendChild(link));
      yield (0, _effects.call)(() => link.click());
      yield (0, _effects.call)(() => link.parentNode.removeChild(link));
    } catch (error) {
      /** add error handler */
      // eslint-disable-next-line no-console
      yield (0, _effects.call)(() => console.log('catch', error, type));
      yield (0, _effects.put)((0, _paulCorePackage.requestError)(type, {
        message: error.formError
      }));
    }
  }();
}